export const configs = {
  // NOTE: The key (e.g., 'Skycall') should correspond to the app's hostname identifier
  // For example, 'skycall.yourapi.com' or 'skycall.localhost'
  Skycall: {
    appName: 'Skycall',
    fullCompanyName: 'Sourcera Science and Technology Co., Limited',
    shortCompanyName: 'Sourcera S&T Limited',
    emailForSupport: "skycall@sourcera.com.hk",
    emailForDevelop: "dev@sourcera.com.hk",
    appNamePostfix: ": International Call",
    appDownloadUrl: "https://play.google.com/store/apps/details?id=com.skycall.app.android",
    appAds: "google.com, pub-9948243393537091, DIRECT, f08c47fec0942fa0"
  },
  WhatsCall: {
    appName: 'WhatsCall',
    fullCompanyName: 'Saier Intelligence Science and Technology Co., Limited',
    shortCompanyName: 'Saier IST Limited',
    emailForSupport: "whatscall@saiertec.com",
    emailForDevelop: "dev@saiertec.com",
    appNamePostfix: ": International Call",
    appDownloadUrl: "https://play.google.com/store/apps/details?id=com.whatscall.app.android",
    appAds: "google.com, pub-3829042973983542, DIRECT, f08c47fec0942fa0"
  },
  AnotherApp: {
    appName: 'AnotherApp',
    fullCompanyName: 'Another Company Inc.',
    shortCompanyName: 'Another Co.',
    emailForSupport: "support@another.com",
    emailForDevelop: "dev@another.com",
    appNamePostfix: ": A Different App",
    appDownloadUrl: "https://play.google.com/store/apps/details?id=com.another.app",
    appAds: "google.com, pub-1111111111111111, DIRECT, f08c47fec0942fa0"
  }
};

/**
 * Determines the current app configuration at RUNTIME.
 * In a production environment, it derives the app name from the first part of the hostname.
 * (e.g., 'skycall.yourdomain.com' -> 'Skycall').
 * In development, it defaults to 'Skycall' for convenience.
 * @returns {object} The configuration object for the current app.
 */
export function getCurrentAppConfig() {
  if (process.env.NODE_ENV === 'development') {
    // 1. 优先从 URL 查询参数中获取 app 类型
    const urlParams = new URLSearchParams(window.location.search);
    const urlAppType = urlParams.get('app');

    if (urlAppType && configs[urlAppType]) {
      console.log(`开发模式: 从 URL 参数获取应用类型: ${urlAppType}`);
      return configs[urlAppType];
    }

    // 2. 如果 URL 参数没有，则回退到环境变量 REACT_APP_APP_TYPE
    const envAppType = process.env.REACT_APP_APP_TYPE;
    if (envAppType && configs[envAppType]) {
      console.log(`开发模式: 从环境变量获取应用类型: ${envAppType}`);
      return configs[envAppType];
    }

    // 3. 最后回退到默认的 Skycall
    console.warn(`开发模式: 未从 URL 或环境变量获取到有效应用类型。默认回退到 'Skycall' 配置。`);
    return configs.Skycall;
  } else { // Production build
    const buildAppType = process.env.REACT_APP_APP_TYPE; // Use REACT_APP_APP_TYPE for build
    if (buildAppType && configs[buildAppType]) {
      
      return configs[buildAppType];
    }
    console.error(`生产模式构建错误: REACT_APP_APP_TYPE 未设置或无效 (${buildAppType})。无法确定构建的应用。`);
    throw new Error("REACT_APP_APP_TYPE 环境变量是生产构建所必需的。");
  }
}